import {useEffect} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {Outlet} from 'react-router-dom'
import {MedicalRecordFormOpen} from './MedicalRecordForm'
interface IMedicalRecordModal {
  medicalRecord: any
  close: any
  onSaved?: () => void
}

const MedicalRecordModal = ({medicalRecord, close, onSaved}: IMedicalRecordModal) => {
  const medicalRecordId = medicalRecord.id

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  function closeModal() {
    close()
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_edit_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-1000px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder' style={{color: '#D31145'}}>{`Prontuário`}</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-danger'
                data-kt-users-modal-action='close'
                onClick={closeModal}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body scroll-y'>
              <Outlet />
              <MedicalRecordFormOpen
                medicalRecordId={medicalRecordId}
                close={closeModal}
                onSaved={onSaved}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {MedicalRecordModal}
